export default "__VITE_PUBLIC_ASSET__ed1612b6__"